import { useQuery } from 'react-query'
import { get, Params } from 'api/fetch'
import { Draft, DraftRequestReviewStatus, PaginatedResponse } from 'backoffice/components/Drafts/types/types'

const apiUrl = process.env.REACT_APP_API_V2 ?? ''

const HOURS_IN_DAY = 24
const MAX_RECENT_DRAFTS = 100
const REFETCH_INTERVAL_MS = 30 * 1000
const CACHE_TIME_MS = 5 * 60 * 1000

const getRecentPendingDrafts = async (): Promise<PaginatedResponse<Draft>> => {
  const twentyFourHoursAgo = new Date()
  twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - HOURS_IN_DAY)

  const params: Params = {
    status: DraftRequestReviewStatus.PENDING,
    limit: MAX_RECENT_DRAFTS.toString(),
    offset: '0',
  }

  const res = await get(`${apiUrl}/drop-requests/drafts`, params)

  if (res.status === 200 && res.parsedBody) {
    const responseData = res.parsedBody as PaginatedResponse<Draft>

    const filteredItems = responseData.items
      .filter((item) => {
        const createdAt = new Date(item.createdAt)
        return createdAt >= twentyFourHoursAgo
      })
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

    return {
      ...responseData,
      items: filteredItems,
      total: filteredItems.length,
    }
  }

  throw new Error('Failed to fetch recent console petitions')
}

export const useRecentDraftsQuery = () => {
  return useQuery(['recentDrafts'], getRecentPendingDrafts, {
    refetchInterval: REFETCH_INTERVAL_MS,
    staleTime: 0,
    cacheTime: CACHE_TIME_MS,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, REFETCH_INTERVAL_MS),
  })
}
